import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { formatAmount } from '../../../utils/formatAmount';
import { getValueProperty } from '../../../utils/refund';

function CreditRefundedDropdown({ totalCreditRefunded, handleViewAll, user = false }) {



    return (
        <Dropdown align="end">
            <Dropdown.Toggle variant="success" id="dropdown-basic">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="7"
                    viewBox="0 0 13 7"
                    fill="none"
                >
                    <path
                        d="M0.601562 0.5L0.601563 3.0462L6.80156 6.5L6.80156 3.9538L0.601562 0.5Z"
                        fill="#02171D"
                    />
                    <path
                        d="M13 0.5L13 3.0462L6.8 6.5L6.8 3.9538L13 0.5Z"
                        fill="#02171D"
                    />
                </svg>
            </Dropdown.Toggle>

            <Dropdown.Menu>
                {totalCreditRefunded && totalCreditRefunded.length > 0 ? (
                    <>
                        {totalCreditRefunded.map((item, index) => {
                            const propertyName = getValueProperty(item);
                            const value = propertyName ? item[propertyName] : 0;

                            return (
                                <div className="text" key={item._id || index}>
                                    <p>{item._id}</p>
                                    <h6>{formatAmount(value, user)}</h6>
                                </div>
                            );
                        })}
                        <div onClick={handleViewAll} className="text">
                            <h6>View All</h6>
                        </div>
                    </>
                ) : (
                    <div className="text">
                        <p>No data available</p>
                    </div>
                )}
            </Dropdown.Menu>
        </Dropdown>
    );
}

export default CreditRefundedDropdown;
// import React from 'react';
// import { Dropdown } from 'react-bootstrap';

// function CreditRefundedDropdown({ totalCreditRefunded, handleViewAll }) {
//     // Format the amount for display
//     // const formatAmount = (amount) => {
//     //     if (!amount && amount !== 0) return '$0';

//     //     if (amount >= 1000000) {
//     //         return `$${(amount / 1000000).toFixed(1)}M`;
//     //     }
//     //     return `$${(amount / 1000).toFixed(0)}K`;
//     // };
//     const formatAmount = (amount) => {
//         if (!amount && amount !== 0) return '$0';

//         if (amount >= 1000000) {
//             return `$${(amount)}`;
//         }
//         return `$${amount}`;
//     };
//     return (
//         <Dropdown align="end">
//             <Dropdown.Toggle variant="success" id="dropdown-basic">
//                 <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     width="13"
//                     height="7"
//                     viewBox="0 0 13 7"
//                     fill="none"
//                 >
//                     <path
//                         d="M0.601562 0.5L0.601563 3.0462L6.80156 6.5L6.80156 3.9538L0.601562 0.5Z"
//                         fill="#02171D"
//                     />
//                     <path
//                         d="M13 0.5L13 3.0462L6.8 6.5L6.8 3.9538L13 0.5Z"
//                         fill="#02171D"
//                     />
//                 </svg>
//             </Dropdown.Toggle>

//             <Dropdown.Menu>
//                 {totalCreditRefunded && totalCreditRefunded.length > 0 ? (
//                     <>
//                         {totalCreditRefunded.map((item, index) => (
//                             <div className="text" key={item._id || index}>
//                                 <p>{item._id}</p>
//                                 <h6>{formatAmount(item.creditRefunded)}</h6>
//                             </div>
//                         ))}
//                         <div onClick={handleViewAll} className="text">
//                             <h6>View All</h6>
//                         </div>
//                     </>
//                 ) : (
//                     <div className="text">
//                         <p>No data available</p>
//                     </div>
//                 )}
//             </Dropdown.Menu>
//         </Dropdown>
//     );
// }

// export default CreditRefundedDropdown;